var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatureIconBranded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4239_173)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#CFFAFE"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4239_173)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37 33H34C33.7348 33 33.4804 33.1054 33.2929 33.2929C33.1054 33.4804 33 33.7348 33 34V54C33 54.2652 33.1054 54.5196 33.2929 54.7071C33.4804 54.8946 33.7348 55 34 55H37V33Z",
    fill: "#29D2D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 55H49V33H39V55ZM44 51C43.7348 51 43.4804 50.8946 43.2929 50.7071C43.1054 50.5196 43 50.2652 43 50C43 49.7348 43.1054 49.4804 43.2929 49.2929C43.4804 49.1054 43.7348 49 44 49C44.2652 49 44.5196 49.1054 44.7071 49.2929C44.8946 49.4804 45 49.7348 45 50C45 50.2652 44.8946 50.5196 44.7071 50.7071C44.5196 50.8946 44.2652 51 44 51ZM44 37C44.2652 37 44.5196 37.1054 44.7071 37.2929C44.8946 37.4804 45 37.7348 45 38C45 38.2652 44.8946 38.5196 44.7071 38.7071C44.5196 38.8946 44.2652 39 44 39C43.7348 39 43.4804 38.8946 43.2929 38.7071C43.1054 38.5196 43 38.2652 43 38C43 37.7348 43.1054 37.4804 43.2929 37.2929C43.4804 37.1054 43.7348 37 44 37ZM44 43C44.2652 43 44.5196 43.1054 44.7071 43.2929C44.8946 43.4804 45 43.7348 45 44C45 44.2652 44.8946 44.5196 44.7071 44.7071C44.5196 44.8946 44.2652 45 44 45C43.7348 45 43.4804 44.8946 43.2929 44.7071C43.1054 44.5196 43 44.2652 43 44C43 43.7348 43.1054 43.4804 43.2929 43.2929C43.4804 43.1054 43.7348 43 44 43Z",
    fill: "#29D2D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 33H51V55H54C54.2652 55 54.5196 54.8946 54.7071 54.7071C54.8946 54.5196 55 54.2652 55 54V34C55 33.7348 54.8946 33.4804 54.7071 33.2929C54.5196 33.1054 54.2652 33 54 33Z",
    fill: "#29D2D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4239_173",
    x: -8,
    y: 2,
    width: 104,
    height: 104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.172549 0 0 0 0 0.25098 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4239_173"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4239_173",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4239_173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIconBranded);
export default __webpack_public_path__ + "static/media/feature-icon-branded.f89e53d12aab21da7ebc96cc0843964e.svg";
export { ForwardRef as ReactComponent };